<template>
  <CCardBody>
    <div class="text-right btngroup top_buttons">
      <CButton
          class="deleteBtn"
          @click="importPriceLists"
      >
        Import
      </CButton>
      <b-button
          class="deleteBtn ml-3"
          size="lg"
          @click="DeleteSkus"
      >
        Delete
      </b-button>
      <CButton
          class="addBtn ml-3"
          @click="ResetForm"
      >
        Create
      </CButton>
    </div>
    <filter-items v-model="filter" :options="filter_options" :searchHandler="updateTable"></filter-items>
    <search-items v-model="search" :searchHandler="updateTable"></search-items>

    <b-table
        :items="Skus"
        :fields="titles"
        ref="b_table"
        hover.
        sorter
    >
      <template #cell(id)="{item}">
        <b-form-checkbox
            :id="'checkbox_'+item.id"
            v-model="checkbox"
            name="checkbox-1"
            :value="item.id"
            unchecked-value="not_accepted"
        >
        </b-form-checkbox>
      </template>
      <template #cell(type)="item">
        <span v-if="item.item.type == 'addon'">Add-on</span>
        <span v-else-if="item.item.type == 'logo-tech'">Logo Technology</span>
        <span v-else>Sku</span>
      </template>
      <template #cell(actions)="item">

        <edit class="mr-2" @click.prevent="editSKU(item)" :id="item.item.id" fillColor="#009FE3"/>
        <span style="font-size: 30px; display: inline-block; cursor: pointer;" v-if="(item.item.factory && item.item.factory.asana_project_id != null)"
              class="ml-2" v-b-tooltip.auto="`Assign Asana task templates`"
              :id="item.id" @click="getAsanaTaskTemplates(item.item)">
              <svg viewBox="0 0 460.000000 255.000000" height="1em" width="1em"
                   preserveAspectRatio="xMidYMid meet" style="margin-top: 10px;">

              <g transform="translate(0.000000,455.000000) scale(0.100000,-0.100000)"
                 fill="currentColor" stroke="none">
                <path d="M180 3535 l0 -845 845 0 845 0 0 845 0 845 -845 0 -845 0 0 -845z
m1382 457 c37 -36 47 -96 25 -138 -9 -16 -193 -206 -409 -421 l-394 -393 -42
0 c-62 0 -85 15 -204 138 -83 85 -108 117 -113 145 -10 49 19 106 65 131 57
30 101 17 177 -57 l64 -61 332 332 c183 182 346 338 362 347 43 23 101 13 137
-23z"/>
                <path d="M2382 3908 l3 -123 978 -3 977 -2 0 125 0 125 -980 0 -981 0 3 -122z"/>
                <path d="M2380 3160 l0 -120 765 0 765 0 0 120 0 120 -765 0 -765 0 0 -120z"/>
              </g>
            </svg>
            </span>

      </template>
    </b-table>
    <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.rows"
        :per-page="pagination.perPage"
        aria-controls="itemList"
        align="center"
        @change="handlePagination"
        v-if="pagination.total > 0"
    ></b-pagination>

    <b-modal id="skuModal" size="lg" no-close-on-backdrop>
      <template #modal-title>
        <span>Create New SKU/Addon {{ role_name }}</span>
      </template>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-6 my-2">
              <label class="required">Select Type</label>
              <v-select
                  id="sku_addone_option"
                  :options="type_options"
                  name="sku_addone_option"
                  v-model="form.addon.type"
                  placeholder="Select Type"
                  :clearable="false"
              />
            </div>
            <template v-if="form.addon.type.id == 'addon' || form.addon.type.id == 'logo-tech'">
              <div class="col-md-2">
                <label class="font-xs">Preselected</label>
                <b-form-checkbox switch size="lg" v-model="form.addon.is_selected"></b-form-checkbox>
              </div>
            </template>

          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group id="sku-number" label-for="sku-number">
                <label class="required">SKU name</label>
                <ValidationProvider ref="createSkuIdProvider" rules="required" name="sku name" :immediate="true"
                                    v-slot="{ errors }">
                  <b-form-input id="sku_id" v-model="form.sku_id" name="sku_id"
                                aria-describedby="sku_id-feedback"></b-form-input>
                  <div v-if="errors.length > 0" class="error_msg">
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </b-form-group>

            </div>
            <div class="col-md-4">
              <label for="required">Size Chart</label>
              <b-form-file
                  v-model="add_file"
                  accept=".jpeg, .png, .jpg, .svg"
                  name="file"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
              ></b-form-file>
            </div>
            <template v-if="form.addon.type.id == 'addon'">
              <div class="col-md-4">
                <label class="font-xs">Approval Required</label>
                <b-form-checkbox switch size="lg" v-model="form.design_customer_approval" />
              </div>
            </template>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-2">
              <b-form-group id="sku_sizechart_reference" label-for="sizechart_reference">
                <label class="required font-xs">Size Chart Reference</label>
                <b-form-input id="sizechart_reference" v-model="form.sizechart_reference" v-validate="{ max: 250}"
                              name="sizechart_reference" aria-describedby="sku_id-feedback"></b-form-input>
                <div v-if="errors && errors.first('sizechart_reference')" class="error_msg">
                  You cannot add more than 250 characters.
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3 my-2">
              <label class="font-xs">Select MOQ Option</label>
              <v-select
                  id="minimum_order_quantity_type"
                  :options="moq_options"
                  name="minimum_order_quantity_type"
                  v-model="form.minimum_order_quantity_type_holder"
                  placeholder="Select MOQ Option"
                  class="font-xs"
              />
            </div>
            <div class="col-md-2 my-2">
              <label class="font-xs">MOQ</label>
              <b-form-input v-validate="{numeric: true}" name="moq"
                            v-model="form.minimum_order_quantity"></b-form-input>
              <div v-if="errors && errors.first('moq')" class="error_msg">
                value should be numeric
              </div>
            </div>
            <div class="col-md-2 my-2">
              <label class="font-xs">Reorders follows MOQ</label>
              <b-form-checkbox switch size="md" v-model="form.reorder_follows_moq"/>
            </div>
            <div class="col-md-2 my-2">
              <label class="font-xs">Production Days</label>
              <b-form-input v-validate="{numeric: true}" name="production_days"
                            v-model="form.production_days"></b-form-input>
            </div>
          </div>
          <div class="row" v-if="add_file_url && add_file_url.length > 0">
            <div class="col-md-6 my-2">
              <div style="margin-top:10px ">
                <label style="display: block">Uploaded image</label>
                <img class="cat_upload_image" :src="add_file_url" style="max-width: 100%;height:150px">
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <label for="required">Specs Sheet</label>
              <b-form-file
                  v-model="form.specs_sheet_info.file"
                  name="spec_sheet_file"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
              ></b-form-file>
            </div>
            <div class="col-md-6">
              <label>External Sku</label>
              <b-form-input v-validate="{ required: false, regex: /^[a-zA-Z0-9@#\$%\^&\*\(\)\-_\+=!\.,\s]{1,255}$/ }" name="external_sku"
                            v-model="form.external_sku"
                            placeholder="Optional External sku"></b-form-input>
              <div v-if="errors && errors.first('external_sku')" class="error_msg">
                value should be alpha numeric string
              </div>
            </div>
          </div>
        </div>
        <div class="row m-0">
          <div class="col-md-12">
            <b-form-group id="note" label-for="note">
              <label>Internal Notes</label>
              <b-form-textarea v-model="form.note" name="note" id="note"></b-form-textarea>
            </b-form-group>

            <b-form-group id="description" class="mt-2" label-for="description">
              <label class="required">SKU Description</label>
              <vue-editor v-model="form.description" name="description" v-validate="{required: true}"></vue-editor>
              <div v-if="errors && errors.first('description')" class="error_msg">
                This field is required.
              </div>
            </b-form-group>
            <div class="row my-2" v-if="currencies.length > 0">
              <div class="col-md-12">
                <h6>Price in different Currencies</h6>
                <CTabs variant="tabs" :active-tab="createtabPaneActiveKey">
                  <template v-for="(currency,index) in currencies">
                    <CTab :title="currency.code" :key="currency.id + index">
                      <b-form-group :id="currency.id + currency.code" :label-for="currency.code" class="my-2">
                        <label>{{ currency.name }}</label>
                        <b-form-input :id="currency.code" v-model="currency.price" :name="currency.code"></b-form-input>
                      </b-form-group>
                    </CTab>
                  </template>
                </CTabs>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <button class="btn btn-primary" @click="submit">Save</button>
      </template>
    </b-modal>
    <b-modal id="edit-skuModal" size="lg" no-close-on-backdrop>
      <template #modal-title>
        <span>Edit SKU/product</span>
      </template>

      <b-tabs pills>
        <b-tab>
          <template #title>
            General
          </template>

          <div class="row mt-2">
            <div class="col-12">
              <div class="row">
                <div class="col-md-6 my-2">
                  <label class="required">Select Type</label>
                  <v-select
                      id="sku_addone_option_update"
                      :options="type_options"
                      name="sku_addone_option_update"
                      v-model="form.addon.type"
                      placeholder="Select Type"
                      :clearable="false"
                  />
                </div>
                <div class="col-md-6 my-2" :class="{ 'col-md-4': form.addon.type.id == 'addon' }">
                  <label>Pattern Name</label>
                  <b-form-input v-model="form.pattern_name"></b-form-input>
                </div>
                <template v-if="form.addon.type.id == 'addon'" >
                  <div class="col-md-2">
                    <label class="font-xs">Preselected</label>
                    <b-form-checkbox switch size="lg" v-model="form.addon.is_selected"></b-form-checkbox>
                  </div>
                </template>

              </div>
              <div class="row">
                <div class="col-md-6">
                  <b-form-group id="sku-number" label-for="sku-number">
                    <label class="required">SKU name</label>
                    <ValidationProvider ref="editSkuIdProvider" rules="required" name="sku name"
                                        :immediate="true" v-slot="{ errors }">
                      <b-form-input id="sku_id" v-model="edit.sku_id" name="sku_id"
                                    aria-describedby="sku_id-feedback"></b-form-input>
                      <div v-if="errors.length > 0" class="error_msg">
                        {{ errors[0] }}
                      </div>
                    </ValidationProvider>
                  </b-form-group>
                </div>
                <div :class="editFileUrl ? 'col-md-2' : 'col-md-4'">
                  <label for="required">Size Chart</label>
                  <b-form-file
                      v-model="edit_file"
                      accept=".jpeg, .png, .jpg, .svg"
                      name="file"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                  ></b-form-file>
                </div>
                <div class="col-md-2" v-if="editFileUrl">
                  <div>
                    <label style="display: block">View Chart</label>
                    <a :href="editFileUrl" class="btn btn-primary" target="_blank">View Chart</a>
                    <!--                   <img class="cat_upload_image" :src="editFileUrl" style="max-width: 100%;height:150px">-->
                  </div>
                </div>
                <div class="col-md-2">
                  <label class="font-xs">Approval Required</label>
                  <b-form-checkbox switch size="lg" v-model="edit.design_customer_approval" />
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-md-3 my-2 font-xs">
                  <b-form-group id="sku_sizechart_reference" label-for="sizechart_reference">
                    <label class="required">Size Chart Reference</label>
                    <b-form-input id="sizechart_reference" v-model="edit.sizechart_reference" v-validate="{ max: 250}"
                                  name="sizechart_reference" aria-describedby="sku_id-feedback"></b-form-input>
                    <div v-if="errors && errors.first('sizechart_reference')" class="error_msg">
                      You cannot add more than 250 characters.
                    </div>
                  </b-form-group>
                </div>
                <div class="col-md-3 my-2">
                  <label class="font-xs">Select MOQ Option</label>
                  <v-select
                      id="minimum_order_quantity_type"
                      :options="moq_options"
                      name="minimum_order_quantity_type"
                      v-model="moq_type"
                      placeholder="Select MOQ Option"
                  />
                </div>
                <div class="col-md-2 my-2">
                  <label class="font-xs">MOQ</label>
                  <b-form-input v-validate="{numeric: true}" name="moq"
                                v-model="edit.minimum_order_quantity"></b-form-input>
                  <div v-if="errors && errors.first('moq')" class="error_msg">
                    value should be numeric
                  </div>
                </div>
                <div class="col-md-2 my-2">
                  <label class="font-xs">Reorders follow MOQ</label>
                  <b-form-checkbox switch size="md" v-model="edit.reorder_follows_moq"/>
                </div>
                <div class="col-md-2 my-2">
                  <label class="font-xs">Production Days</label>
                  <b-form-input v-validate="{numeric: true}" name="production_days"
                                v-model="edit.production_days"></b-form-input>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-6">
                  <label for="required">Specs Sheet</label>
                  <b-form-file
                      v-model="edit.specs_sheet_info.file"
                      name="spec_sheet_file"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                      accept="image/*"
                  ></b-form-file>
                  <!-- Display the already uploaded file URL if available -->
                  <div class="my-2" v-if="specFileUrl">
                    <a :href="specFileUrl" class="btn btn-primary btn-sm" target="_blank">View Specs Sheet</a>
                    <!--                   <img class="cat_upload_image" :src="editFileUrl" style="max-width: 100%;height:150px">-->
                  </div>
                </div>
                <div class="col-md-6">
                  <label>External Sku</label>
                  <b-form-input v-validate="{ required: false, regex: /^[a-zA-Z0-9@#\$%\^&\*\(\)\-_\+=!\.,\s]{1,255}$/ }" name="external_sku"
                                v-model="edit.external_sku"
                                placeholder="Optional External sku"></b-form-input>
                  <div v-if="errors && errors.first('external_sku')" class="error_msg">
                    value should be alpha numeric string
                  </div>
                </div>
              </div>
            </div>
            <div class="row m-0">
              <div class="col-md-12">
                <b-form-group id="note" label-for="note">
                  <label>Internal Notes</label>
                  <b-form-textarea v-model="edit.note" name="note" id="note"></b-form-textarea>
                </b-form-group>

                <b-form-group id="description" label-for="description" class="mt-2">
                  <label class="required">SKU Description</label>
                  <vue-editor v-model="edit.description" name="description" v-validate="{required: true}"></vue-editor>
                  <div v-if="errors && errors.first('description')" class="error_msg">
                    This field is required.
                  </div>
                </b-form-group>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab>
          <template #title>
            Prices
          </template>
          <div class="mt-2" v-if="currencies.length > 0">
            <div class="col-md-12">
              <div class="mt-2">
                <h4>MSRP</h4>
                <div
                    style="display: grid; grid-template-columns: auto auto auto auto auto auto auto auto auto auto auto auto; gap: 0 10px">
                  <template v-for="(currency,index) in currencies">
                    <b-form-group :key="currency.id + index" :id="currency.id + currency.code"
                                  :label-for="currency.code" class="my-2">
                      <label>{{ currency.code }}</label>
                      <b-form-input :id="currency.code" v-model="currency.price" :name="currency.code"
                        @change="(val) => { currency.price = val.toString().replace(',', '.') }">
                      </b-form-input>
                    </b-form-group>
                  </template>
                </div>
              </div>
              <div class="mt-2">
                <h4>Net Pricing</h4>
                <div
                    style="display: grid; grid-template-columns: auto auto auto auto auto auto auto auto auto auto auto auto; gap: 0 10px">
                  <template v-for="(currency,index) in currencies">
                    <b-form-group :key="currency.id + index" :id="`${currency.id}`" :label-for="currency.code" class="my-2">
                      <label>{{ currency.code }}</label>
                      <b-form-input v-model="currency.net_price"
                        @change="(val) => { currency.net_price = val.toString().replace(',', '.') }">
                      </b-form-input>
                    </b-form-group>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
      <template #modal-footer>
        <button class="btn btn-primary" @click="editSubmit">Save</button>
      </template>
    </b-modal>
    <b-modal id="importExcelModal" size="md" no-close-on-backdrop hide-footer>
      <template #modal-title>
        <span>Import Price List</span>
      </template>
      <b-form>
        <b-form-group>
          <b-form-file v-model="price_list_template"></b-form-file>
        </b-form-group>
      </b-form>

      <CRow>
        <CCol col="12" class="text-right">
          <button @click="handlePriceListImport" class="btn btn-primary mt-3">
            Save
          </button>
        </CCol>
      </CRow>
    </b-modal>
    <b-modal id="asanaTaskTemplateModal"  @hidden="ResetAsanaForm" size="lg" no-close-on-backdrop  hide-footer>
      <template #modal-title>
        Bind Asana Task Template with
        <span v-if="!asana_form.name">SkuID</span>
        <span v-else>{{asana_form.name}}</span>
      </template>
      <CRow>
        <CCol class="col-12">
          <label>Asana Task Templates</label>
          <v-select
              v-model="asana_form.asana_task_template_id"
              v-validate="{required: true}"
              :options="asana_task_templates"
              name="asana_task_template"
              placeholder="Select Template"
          >
          </v-select>
          <div v-if="errors && errors.first('asana_task_template_id')" class="error_msg">
            {{errors.first('asana_task_template_id')}}
          </div>

          <label style="margin-top: 10px">Asana Task Template Reorder</label>
          <v-select
              v-model="asana_form.asana_task_template_id_reorder"
              v-validate="{required: true}"
              :options="asana_task_templates"
              name="asana_task_template_id_reorder"
              placeholder="Select Template"
          >
          </v-select>
          <div v-if="errors && errors.first('asana_task_template_id_reorder')" class="error_msg">
            {{errors.first('asana_task_template_id_reorder')}}
          </div>


          <b-button @click="assignAsanaTaskTemplate" class="mt-2 float-right" variant="primary">Assign</b-button>
        </CCol>
      </CRow>
    </b-modal>
  </CCardBody>
</template>
<script>
import { http } from "@/config/httpCommon";
import { getLastPage, setPageModal } from "@/helpers/Helpers";
import { ValidationProvider } from "vee-validate";
import Vue from 'vue';
import Edit from 'vue-material-design-icons/Pencil.vue';
import "vue-select/dist/vue-select.css";
import { VueEditor } from "vue2-editor";
import FilterItems from "../../components/FilterItems";
import SearchItems from "../../components/SearchItems";

export default {
  name: "SkuListing",
  components: {
    SearchItems,
    FilterItems,
    Edit,
    VueEditor,
    ValidationProvider
  },
  computed: {
    getCurrencies() {
      return this.$store.getters.getCurrencies;
    },
    Skus() {
      return this.$store.getters.getSku;
    },
    editFileUrl: {
      get() {
        return this.edit_file_url;
      },
      set(value) {
        this.edit_file_url = value;
      }
    },
    specFileUrl: {
      get() {
        return this.specs_sheet_url;
      },
    }
  },
  async created() {
    try {
      await this.$store.commit('set', ['showLoader', true]);
      this.$store.dispatch('currencies').then((currencies) => {
        this.currencies = currencies;
        this.net_prices = currencies;
        this.currencies.map((currency) => {
          currency.price = null;
          currency.net_price = null;
          return currency
        });
      });
      await this.$store.dispatch('factories', '?paginate=false');
      await this.$store.dispatch('countries');
      this.preservePaginationIgnoreSearch('page', 'search', this.$route.name, this.getSku);
      await this.$store.commit('set', ['showLoader', false]);
    } catch (err) {
      await this.$store.commit('set', ['showLoader', false]);
      this.showToast(err.messaage, 'DANGER');
    }


  },
  data() {
    return {
      moq_options: [
        {id: 'by_design', label: 'By Design Total'},
        {id: 'by_cart', label: 'By Cart Total'},
      ],
      type_options: [
        {id: 'sku', label: 'Sku'},
        {id: 'addon', label: 'Add-on'},
        {id: 'logo-tech', label: 'Logo Technology'},
      ],
      filter_options: [
        {id: "all", label: 'Select option'},
        {id: 'sku', label: 'Sku'},
        {id: 'addon', label: 'Add-on'},
        {id: 'logo-tech', label: 'Logo Technology'},
      ],
      filter: {id: "all", label: 'Select option'},
      range: null,
      currency: '',
      country: '',
      moq_type: '',
      factory: '',
      checkbox: [],
      titles: [
        {key: 'id', label: '', sorter: false},
        {key: 'sku_id', label: 'SKU Name'},
        {key: 'sku_number'},
        {key: 'type', label: 'Type'},
        {key: 'actions', label: 'Actions'},
      ],
      form: {
        sku_id:  '',
        pattern_name: '',
        minimum_order_quantity: '',
        production_days: '',
        reorder_follows_moq: false,
        minimum_order_quantity_type_holder: {id: 'by_design', label: 'By Design Total'},
        addon: {
          type: {id: 'sku', label: 'Sku'},
          is_selected: true
        },
        external_sku:'',
        description: '',
        ranges: [
          {
            delete: 0,
            from: '',
            to: '',
            price: '',
            min: 1,
          }
        ],
        sizechart_reference: null,
        specs_sheet_info: {
          file: null,
          file_url: null
        },
        design_customer_approval:true,
      },
      add_file: null,
      add_file_url: '',
      edit: {
        id:'',
        sku_id:  '',
        pattern_name: '',
        minimum_order_quantity: '',
        reorder_follows_moq: false,
        production_days: '',
        minimum_order_quantity_type: '',
        external_sku:'',
        description: '',
        note: '',
        ranges: [
          {
            delete: 0,
            from: '',
            to: '',
            price: '',
            min: 1,
          }
        ],
        sizechart_reference: null,
        specs_sheet_info: {
          file: null,
          file_url: null
        },
        design_customer_approval: true,
      },
      edit_file: null,
      edit_file_url: '',
      specs_sheet_url:'',
      // skus: [],
      isBusy: false,
      search: '',
      pagination: {
        rows: null,
        currentPage: null,
        perPage: null,
        total: 0
      },
      key: 0,
      base_url: process.env.VUE_APP_FILE_URL,
      edittabPaneActiveKey: 0,
      createtabPaneActiveKey: 0,
      currencies: [],
      net_prices: [],
      price_list_template: null,
      asana_task_templates:[],
      asana_form: {
        selected_sku_id:null,
        name: '',
        asana_task_template_id:{id:null,label:'Select Asana task template'},
        asana_task_template_id_reorder:{id:null,label:'Select Asana task template reorder'}
      }
    }
  },
  methods: {
    async getSku(params) {
      let res = await this.$store.dispatch('getSku', params);
      this.skus = this.$store.getters.getSku;
      this.makePagination(res.data.meta)
    },
    async editSKU(item) {
      this.edit = Object.assign({}, item.item);
      this.edit.specs_sheet_info = {file: null, file_url: this.edit.specs_sheet_url}

      const type_option = this.type_options.find(option => {
        return option.id === item.item.type
      });
      this.form.addon.type = type_option;
      if (type_option.id == 'addon') {
        this.form.addon.is_selected = (item.item.is_selected) ? true : false
      }

      this.key = item.item.id;
      if (this.role_name == 'factory') {
        let factories = [];
        let total = this.$store.getters.getFactories
        for (let i = 0; i < total.length; i++) {
          factories[i] = {id: total[i].id, label: total[i].name + ' [' + total[i].factory_id + ']'};
        }
        const factory = factories.find(factory => {
          return factory.id === item.item.factory_id
        });
        this.factory = factory;
      }
      const countries = this.$store.getters.getCountries;
      const country = countries.find(country => {
        return country.id === item.item.country_of_origin
      });
      this.country = country;
      const moq_type = this.moq_options.find(option => {
        return option.id === item.item.minimum_order_quantity_type
      });
      if (item.item.skucurrency.length > 0) {
        this.currencies.map((currency) => {
          currency.price = null;
          currency.net_price = null;
          return currency
        });
        item.item.skucurrency.forEach((currency) => {
          let currencyIndex = this.currencies.findIndex((cur) => {
            return cur.id === currency.pivot.currency_id;
          });
          if (currencyIndex > -1) {
            this.currencies[currencyIndex].price = currency.pivot.price;
            this.currencies[currencyIndex].net_price = currency.pivot.net_price;
          }
        });
      } else {
        this.currencies.map((currency) => {
          currency.price = null;
          currency.net_price = null;
          return currency
        });
      }
      this.moq_type = moq_type;
      if (item.item.image_url) {
        this.edit_file_url = this.base_url + '/' + item.item.image_url;
      } else {
        this.edit_file_url = null;
      }

      if (item.item.specs_sheet_url) {
        this.specs_sheet_url = this.base_url + '/' + item.item.specs_sheet_url;
      } else {
        this.specs_sheet_url = null;
      }
      if (item.item.reorder_follows_moq) {
        this.edit.reorder_follows_moq = item.item.reorder_follows_moq === 1 ? true : false;
      }
      this.edit.design_customer_approval = this.edit.design_customer_approval === 1? true: false;
      this.$bvModal.show("edit-skuModal");
    },
    makePagination(data) {
      this.pagination.currentPage = data.current_page;
      this.pagination.rows = data.total;
      this.pagination.perPage = data.per_page;
      this.pagination.total = data.total;
    },
    addComponent() {
      let valid = this.validateRanges();
      if (valid) {
        this.form.ranges.push({
          delete: 1,
          from: '',
          to: '',
          price: '',
        });
      }

    },
    validateRanges() {
      let length = this.form.ranges.length;
      let range = this.form.ranges[length - 1];
      let newcomp = true;
      if (range.from != '' && range.to != '' && Number(range.from) < Number(range.to)) {
        if (length > 1) {
          let prev = this.form.ranges[length - 2];
          if (Number(range.from) > Number(prev.to)) {
            newcomp = true;
          } else {
            newcomp = false;
          }
        } else {
          newcomp = true;
        }
        if (newcomp) {
          newcomp = true;
        } else {
          newcomp = false;
          this.showToast('From of last range should be greater than To range of previous range', 'DANGER');
        }
      } else {
        newcomp = false;
        this.showToast('To and From ranges should not be empty and To range is greater than from', 'DANGER');
      }
      return newcomp;
    },
    ResetForm() {
      this.form.sku_id = '';
      this.form.description = '';
      this.form.addon = {
        type: {id: 'sku', label: 'Sku'},
        is_selected: true
      }
      this.form.currency_id = 0;
      this.form.minimum_order_quantity = '';
      this.form.reorder_follows_moq = false;
      this.form.design_customer_approval = true;
      this.form.ranges= [{
        delete: 0,
        from: '',
        to: '',
        price: '',
        min: 1,
      }];
      this.factory = '';
      this.currencies.map((currency) => {
        currency.price = null;
        currency.net_price = null;
        return currency
      });
      this.$bvModal.show("skuModal");
    },
    ResetAsanaForm() {
      this.asana_form = {
        selected_sku_id:null,
        name: '',
        asana_task_template_id:{id:null,label:'Select Asana task template'},
        asana_task_template_id_reorder:{id:null,label:'Select Asana task template Reorder'}
      }
      this.$bvModal.hide("asanaTaskTemplateModal");
    },
    SelectedFactory(e) {
      let code = ''
      let currency_id = 0;
      if (e && e.id) {
        this.getCurrencies.forEach(element => {
          if (e.id == element.id) {
            code = element.symbol;
            currency_id = element.id;
            return '';
          }
        });
      }
      this.currency = code;
      this.form.currency_id = currency_id;
    },
    async submit() {
      let valid = await this.$validator.validate();
      if (valid) {
        if (this.role_name == 'factory') {
          this.form.factory_id = this.factory.id;
        }
        if (this.country) {
          this.form.country_of_origin = this.country.id;
        }
        this.form.minimum_order_quantity_type = this.form.minimum_order_quantity_type_holder.id;
        this.form.currencies = this.currencies;
        await this.$store.commit('set', ['showLoader', true]);
        try {
          await this.$store.dispatch('addSku', {data: this.form, file: this.add_file, spec_file: this.form.specs_sheet_info.file});
          this.skus = this.$store.getters.getSku;
          this.nextPageOnCreation('page', 'search', this.skus.length, this.pagination.perPage, this.pagination.currentPage, getLastPage(this.pagination.perPage, this.pagination.total), this.$route.name, this.getSku);
          this.$bvModal.hide("skuModal");
          this.form= {
            sku_id:  '',
            pattern_name: '',
            minimum_order_quantity: '',
            production_days: '',
            reorder_follows_moq: false,
            minimum_order_quantity_type_holder: {id: 'by_design', label: 'By Design Total'},
            addon: {
              type: {id: 'sku', label: 'Sku'},
              is_selected: true
            },
            external_sku:'',
            description: '',
            ranges: [
              {
                delete: 0,
                from: '',
                to: '',
                price: '',
                min: 1,
              }
            ],
            sizechart_reference: null,
            specs_sheet_info: {
              file: null,
              file_url: null
            },
            design_customer_approval:true,
          },
          this.showToast('SKU added successfully', 'SUCCESS');
          this.$store.commit('set', ['showLoader', false]);
        } catch (err) {
          const {data = null} = err.response ? err.response : {}
          if (data && data.errors && data.errors.sku_name && data.errors.sku_name.length > 0) {
            this.$refs.createSkuIdProvider.applyResult({
              errors: data.errors.sku_name, // array of string errors
              valid: false, // boolean state
              failedRules: {} // sh
            })
          }
          this.$store.commit('set', ['showLoader', false]);
          this.showErrors(err);
        }
      }
    },
    async editSubmit() {
      let valid = await this.$validator.validate();
      if (valid) {
        if (this.role_name == 'factory') {
          this.edit.factory_id = this.factory.id;
        }
        if (this.country) {
          this.edit.country_of_origin = this.country.id;
        }
        this.edit.minimum_order_quantity_type = this.moq_type.id;
        this.edit.currencies = this.currencies;
        this.edit.net_prices = this.net_prices;
        await this.$store.commit('set', ['showLoader', true]);
        try {
          this.edit.addon = this.form.addon;
          this.edit.pattern_name = this.form.pattern_name;
          let res = await this.$store.dispatch('editSku', {data:this.edit, file:this.edit_file,spec_file:this.edit.specs_sheet_info.file});
          this.$refs.b_table.refresh();
          this.skus = this.$store.getters.getSku;
          this.preservePagination('page', 'search', this.$route.name, this.getSku)
          this.$bvModal.hide("edit-skuModal");
          this.showToast('SKU added successfully', 'SUCCESS');
          this.$store.commit('set', ['showLoader', false]);
        } catch (err) {
          const {data = null} = err.response ? err.response : {}
          if (data && data.errors && data.errors.sku_name && data.errors.sku_name.length > 0) {
            this.$refs.editSkuIdProvider.applyResult({
              errors: data.errors.sku_name, // array of string errors
              valid: false, // boolean state
              failedRules: {} // sh
            })
          }
          this.$store.commit('set', ['showLoader', false]);
          this.showErrors(err);
        }
      }
    },
    async DeleteSkus() {
      try {
        if (this.checkbox.length > 0) {
          let res = await this.$store.dispatch('deleteSkus', this.checkbox);
          if (res.status == 204) {
            this.spinner = false;
            this.skus = this.$store.getters.getSku;
            this.previousPageOnDeletion('page', 'search', this.skus.length, this.$route.name, this.getSku);
            this.checkbox = []
            this.showToast('SKU\'s deleted successfully', 'SUCCESS');
          }
        } else {
          this.showToast('Please select atleast one item', 'ERROR')
        }
      } catch (err) {
        this.showErrors(err);
      }
    },
    showErrors(err) {
      let errRes = err.response.data.errors;
      let errArr = []
      Object.keys(errRes).map((field) => {
        errArr.push(errRes[field][0]);
      });
      errArr = [...new Set(errArr)];
      for (let i = 0; i < errArr.length; i++) {
        this.showToast(errArr[i], 'DANGER');
      }
      this.spinner = false;
    },
    RemoveCompenent(index) {
      this.form.ranges.splice(index, 1);
    },
    async updateTable() {
      try {
        this.$store.commit('set', ['showLoader', true]);
        let params = ''
        if (this.search) {
          params = '?search=' + this.search;
        }
        if (this.filter.id != 'all') {
          params += (this.search) ? '&' : '?';
          params += 'filter=' + this.filter.id
        }
        setPageModal(1, this.$route.name, this.search);
        this.getSku(params);
        this.$store.commit('set', ['showLoader', false]);
      } catch (err) {
        this.$store.commit('set', ['showLoader', false]);
        console.log(err)
      }
    },
    async myFunction(currentPage) {
      this.current_page = currentPage;
      let params = '?skuid=' + this.search + '&page=' + currentPage;
      this.$store.commit('set', ['showLoader', true]);
      await this.$store.dispatch('getSku', params);
      this.$store.commit('set', ['showLoader', false]);
      this.skus = this.$store.getters.getSku;
      this.pages = this.$store.getters.totalPages;
    },
    handlePagination(page = '') {
      let params = '?page=' + page;
      if (this.search) {
        params += '&search=' + this.search
      }
      setPageModal(page, this.$route.name, this.search);
      this.getSku(params);
    },
    importPriceLists() {
      this.$bvModal.show('importExcelModal');
    },
    handlePriceListImport() {
      this.$store.commit('set', ['showLoader', true]);
      const formData = new FormData();
      formData.append('file', this.price_list_template);
      this.$store.dispatch('importExcelTemplate', formData).then(async () => {
        this.$store.commit('set', ['showLoader', false]);
        this.showToast('Prices imported successfully', 'SUCCESS');
        this.$bvModal.hide('importExcelModal')
        let response = await this.$store.dispatch('getSku');
        this.skus = this.$store.getters.getSku;
        this.makePagination(response.data.meta)
      }).catch((err) => {
        this.$store.commit('set', ['showLoader', false]);
        this.$bvModal.hide('importExcelModal')
        this.showError(err);
      });
    },
    async getAsanaTaskTemplates(skuId) {
      this.asana_form.selected_sku_id = skuId.id;
      this.asana_form.name = skuId.sku_id;
      this.$bvModal.show("asanaTaskTemplateModal");
      if(this.asana_task_templates.length < 1) {
        await this.$store.commit('set', ['showLoader', true]);
        await http.get(`/get-asana-task-templates?project_id=${skuId.factory.asana_project_id}`).then((res) => {
          this.$store.commit('set', ['showLoader', false]);
          const optionArray = [];
          optionArray.push({id: null, label: 'Select Asana task template'});
          res.data.map((obj) => {
            optionArray.push({id: obj.gid, label: obj.template.name});
            if(skuId.asana_task_template_id == obj.gid) {
              this.asana_form.asana_task_template_id = {id: obj.gid, label: obj.template.name}
            }
            if(skuId.asana_task_template_id_reorder == obj.gid) {
              this.asana_form.asana_task_template_id_reorder = {id: obj.gid, label: obj.template.name}
            }
          })
          this.asana_task_templates = optionArray
        });

      } else {

        ['asana_task_template_id', 'asana_task_template_id_reorder'].forEach(key => {
          const template = this.asana_task_templates.find(obj => skuId[key] === obj.id);
          if (template) {
            this.asana_form[key] = { id: template.id, label: template.label };
          }
        });


        /*const task_template = this.asana_task_templates.find(obj => skuId.asana_task_template_id === obj.id);
        if (task_template) {
          this.asana_form.asana_task_template_id = { id: task_template.id, label: task_template.label };
        }
        const task_template_reorder = this.asana_task_templates.find(obj => skuId.asana_task_template_id_reorder === obj.id);
        if (task_template_reorder) {
          this.asana_form.asana_task_template_id_reorder = { id: task_template_reorder.id, label: task_template_reorder.label };
        }*/
      }
    },
    async assignAsanaTaskTemplate() {

      const payload = {
        sku_id: this.asana_form.selected_sku_id,
        asana_task_template_id: this.asana_form.asana_task_template_id.id,
        asana_task_template_id_reorder: this.asana_form.asana_task_template_id_reorder.id

      }

      await this.$store.commit('set', ['showLoader', true]);
      await http.post(`/bind-asana-task-template-to-sku-id`, payload).then((res) => {
        this.$store.commit('set', ['showLoader', false]);

        let sku_payload = {id:payload.sku_id, data:
              {
                asana_task_template_id: payload.asana_task_template_id,
                asana_task_template_id_reorder: payload.asana_task_template_id_reorder
              }
        }
        this.$store.commit('UPDATE_SKU_PROPS', sku_payload)

        this.showToast("Sku bound with task templates successfully", "SUCCESS");
        this.$bvModal.hide("asanaTaskTemplateModal");
      });

    }
  },
}


</script>
<style lang="scss" scoped>
.add_range span, .delete_button span {
  cursor: pointer;
}

.delete_button {
  cursor: pointer;
}
</style>
